import PicturesApp from 'station/components/picture/PicturesApp'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'

const ProductionUnitPicturesApp = ({

}) => {
    const {
        productionUnit,
        productionUnits,
    } = useSelector(store => ({
        productionUnit: store.ProductionUnitReducer.productionUnit,
        productionUnits: store.ProductionUnitReducer.productionUnits,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.productionUnit,
        href: 'productionUnit',
    }, {
        title: getStationTitle(productionUnit),
        href: `station/productionUnit/${productionUnit?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/productionUnit/${productionUnit?.id}/picture`,
    }], [productionUnit])

    return (
        <PicturesApp
            stations={productionUnits}
            station={productionUnit}
            stationType='productionUnit'
        />
    )
}

export default ProductionUnitPicturesApp